<template>
     <div class="block20">
           
            <!-- 返回 -->
            <div class="return">
                 <router-link to="/"><span class="arrow"></span>返回首页</router-link>
            </div>
            <!-- 返回 -->
            <!-- 内容 -->
            <div class="container">
              <h2 class="title1">拆卸和安装车身组件</h2>
  
              <div class="container-content">
                <p class="text_line">蓄电池</p>
                <img src="./img/img2.jpg" width="100%">
                <p class="text_square">拆卸</p>
                <p>确认点火开关已 <img class="icon_middle" src="../img/zhinankaiguan.png" alt=""> 关闭。</p>

                <ul class="numberspace">
                  <li><em>1</em>拆下左侧<router-link to="/block20/cehuzhao">盖板</router-link>。</li>
                  <li><em>2</em>拆下螺栓。</li>
                  <li><em>3</em>拆下保持架。</li>
                  <li><em>4</em>从蓄电池上断开 <img class="icon_middle" src="./img/negative-icon.png" alt=""> 负极端子。</li>
                  <li><em>5</em>从蓄电池上断开 <img class="icon_middle" src="./img/plus-icon.png" alt=""> 正极端子。</li>
                  <li><em>6</em>拆下蓄电池，操作时请小心，不要掉落端子螺母。</li>
                </ul>
                
                <p class="text_square">安装</p>
                <p>
                    按照与拆卸相反的顺序安装零件。请务必先连接 <img class="icon_middle" src="./img/plus-icon.png" alt=""> 正极端子。确保螺栓和螺母已紧固。<br>
                    再接入电池后确保<router-link to="/block9">时钟</router-link>重新设置了正确的时间。<br>
                    有关正确处理蓄电池的信息，请参见“<router-link to="/block18/">保养规范</router-link>” “<router-link to="/block33/">蓄电池没电</router-link>”
                </p>
                
                
              
                <p class="text_line" id='anzuo'>鞍座</p>
                <img src="./img/img1.png" width="100%">
                <p class="text_square">拆卸</p>
                <ul class="numberspace">
                  <li><em>1</em>将点火钥匙插入尾灯下方的鞍座锁。</li>
                  <li><em>2</em>顺时针转动直到听到开锁声。</li>
                  <li><em>3</em>双手托住鞍座尾部，上提并往后拖拽鞍座并取下。</li>
                </ul>
                <p class="text_square">安装</p>
                <ul class="numberspace">
                  <li><em>1</em>将车架上的前叉插入鞍座前部的前叉槽内，鞍座后部的后叉插入车架上的后叉槽。</li>
                  <li><em>2</em>从鞍座后部向前推入，直到其锁定到位。轻轻向上拉起鞍座，确认鞍座是否牢固地锁定。<br>
                    安装完成后，鞍座锁自动锁定。<br>小心别把钥匙锁在鞍座下。</li>
                </ul>
        
                <p class="text_line" id='cehuzhao'>侧盖</p>
                <img src="./img/img3.jpg" width="100%">
                <p>可以用相同的方式拆卸右侧和左侧的侧盖。</p>
                <p class="text_square">拆卸</p>
                <p>
                    1.拧下螺钉。<br>
                    2.从扣眼上拆下销子。<br>
                    3.拆下侧盖。
                </p>
                <p class="text_square">安装</p>
                <p>按照与拆卸相反的顺序安装零件</p>
                
              </div>
              <div class="foot-btn">
                <div class="prev">
                  <router-link to="/block19">上一页</router-link>
                </div>
                <div class="next">
                  <router-link to="/block21">下一页</router-link>
                </div>
              </div>
            </div>
        </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>